import { formatPrice } from "./formatPrice";
import { PriceFormattingOptions } from "./types";

/**
 * Formats a price in pennies to be in dollars with the currency symbol.
 */
export const formatPriceWithCurrencySymbol = (
  price: number,
  formattingOptions?: Partial<PriceFormattingOptions>,
  symbol = "$"
): string =>
  price >= 0
    ? `${symbol}${formatPrice(price, formattingOptions)}`
    : `–${symbol}${formatPrice(Math.abs(price), formattingOptions)}`;
